'use client';

import React, { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, Typography } from '@mui/material';

import { useLocale, useTranslate } from 'src/locales';

export default function Counter({ onChange, defaultValue = 1, disabled }) {
  const [count, setCount] = useState(defaultValue);
  const { t } = useLocale();
  const handleIncrement = () => {
    const newCount = count + 1;
    setCount(newCount);
    onChange?.(newCount);
  };

  const handleDecrement = () => {
    if (count > 1) {
      const newCount = count - 1;
      setCount(newCount);
      onChange?.(newCount);
    }
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: 12,
          color: 'text.secondary',
          // lineHeight: '1.4375em',
        }}
      >
        {t('Truck_QTY')}
      </Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <IconButton
          size="small"
          aria-label="qty decrement"
          onClick={handleDecrement}
          disabled={count <= 1 || disabled}
          color="primary"
          sx={{
            bgcolor: (theme) => theme.palette.action.hover, // same as hover bg
            '&:hover': {
              bgcolor: (theme) => theme.palette.action.hover, // keep same on hover
            },
            border: '1px solid',
            borderColor: 'primary.main',
          }}
        >
          <RemoveIcon />
        </IconButton>

        <Typography variant="subtitle1" sx={{ minWidth: 24, textAlign: 'center' }}>
          {count}
        </Typography>

        <IconButton
          disabled={disabled}
          size="small"
          onClick={handleIncrement}
          color="primary"
          aria-label="qty increment"
          sx={{
            bgcolor: (theme) => theme.palette.action.hover, // same as hover bg
            border: '1px solid',
            borderColor: 'primary.main',
            '&:hover': {
              bgcolor: (theme) => theme.palette.action.hover, // keep same on hover
            },
          }}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
